// extracted by mini-css-extract-plugin
var _1 = "h4nzJjZB";
var _2 = "ONGBpfop";
var _3 = "yIJ9t4yZ";
var _4 = "ElQb4mup";
var _5 = "ZlSqZHtJ";
var _6 = "ElQb4mup";
var _7 = "ZlSqZHtJ";
export { _1 as "disabled", _2 as "large", _3 as "selected", _4 as "tab-btn", _5 as "tab-group", _6 as "tabBtn", _7 as "tabGroup" }
